

























import { Component, Provide, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { menu } from "@/config/host.config";

import { AxiosError, AxiosResponse, AxiosRequestConfig } from "axios";
import { IBar } from "@/@types/menu/bars/bars";

import RecuclerBarsList from "@/components/tables/bars/recucler-bars-list.vue";

@Component({
  components: {
    RecuclerBarsList,
  },
})
export default class MenuBarsRecucler extends Vue {
  @Provide() barFolder = "menu/bars";
  barList: IBar[] = [];
  show = false;
  alertMessage = "error.empty";
  variant = "danger";
  bar: IBar | null = null;
  showAdd = true;

  async sendingToServer(id: string): Promise<void> {
    let url = menu.barRestore + "/" + id;
    const changeBar = await axios.put(url);
    if (changeBar.status === 200) {
      this.createBarList();
    }
  }

  async getBars(config: AxiosRequestConfig | undefined): Promise<IBar[]> {
    const url = menu.bars;
    return new Promise((res, rej) => {
      axios
        .get(url, config)
        .then((bars: AxiosResponse) => {
          if (bars.status === 200) {
            res(bars.data);
          }
        })
        .catch((e: AxiosError) => {
          console.log(e);
          rej(e);
        });
    });
  }

  createBarList(): void {
    const config: AxiosRequestConfig = {
      params: {
        "match[deleted][value]": true,
      },
    };
    this.getBars(config)
      .then((bars: IBar[]) => {
        this.barList = bars;
        if (this.barList.length > 0) {
          this.show = true;
          this.alertMessage = "";
        } else {
          this.show = false;
          this.alertMessage = String(
            this.$i18n.t("error.emptyList", {
              name: this.$i18n.t("Menu.name"),
            })
          );
          this.variant = "success";
        }
      })
      .catch((e: AxiosError) => {
        this.show = false;
        this.alertMessage = String(
          this.$i18n.t(`error.${e.response ? e.response.status : e.message}`)
        );
      });
  }

  mounted(): void {
    this.createBarList();
  }
}
